function fromDto(dto) {
  return {
    id: dto.id,
    user_id: dto.userId,
    user_public_id: dto.userPublicId,
    workspace_id: dto.workspaceId,
    display_name: dto.displayName,
    given_name: dto.givenName,
    family_name: dto.familyName,
    email: dto.email,
    picture: dto.picture
  };
}
export { fromDto };
//# sourceMappingURL=ProvidersMapper.js.map
